// extracted by mini-css-extract-plugin
export default {"secondaryheader":"header_secondaryheader__PdEC3"};